import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import EmployeeDashboard from './pages/EmployeeDashboard';

// --- PROTECTED ROUTE (Security Check) ---
const ProtectedRoute = ({ children, allowedRole }) => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));

    if (!token) return <Navigate to="/login" replace />;

    if (allowedRole && (!user.roles || !user.roles.includes(allowedRole))) {
        return <Navigate to="/employee-dashboard" replace />;
    }
    return children;
};

// --- PUBLIC ROUTE (Already Login Check) ---
// Agar user pehle se login hai, to usy login page na dikhao
const PublicRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));

    if (token && user) {
        // Agar admin hai to admin dashboard, warna employee dashboard
        return user.roles.includes('Admin') 
            ? <Navigate to="/dashboard" replace /> 
            : <Navigate to="/employee-dashboard" replace />;
    }
    return children;
};

function App() {
    return (
        <Router>
            <Routes>
                {/* Default route redirect */}
                <Route path="/" element={<Navigate to="/login" replace />} />
                
                {/* LOGIN PAGE - Ab ye check karega ke user pehle se login to nahi */}
                <Route 
                    path="/login" 
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    } 
                />

                {/* --- PROTECTED ROUTES --- */}
                <Route 
                    path="/dashboard" 
                    element={
                        <ProtectedRoute allowedRole="Admin">
                            <Dashboard />
                        </ProtectedRoute>
                    } 
                />

                <Route 
                    path="/employee-dashboard" 
                    element={
                        <ProtectedRoute>
                            <EmployeeDashboard />
                        </ProtectedRoute>
                    } 
                />

                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </Router>
    );
}

export default App;